import { render } from "./MenuForTwo.vue?vue&type=template&id=b533a95c&scoped=true"
import script from "./MenuForTwo.vue?vue&type=script&lang=js"
export * from "./MenuForTwo.vue?vue&type=script&lang=js"

import "./MenuForTwo.vue?vue&type=style&index=0&id=b533a95c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b533a95c"]])

export default __exports__